import { render, staticRenderFns } from "./FieldTable.vue?vue&type=template&id=b8eec06c&scoped=true"
import script from "./FieldTable.vue?vue&type=script&lang=tsx"
export * from "./FieldTable.vue?vue&type=script&lang=tsx"
import style0 from "./FieldTable.vue?vue&type=style&index=0&id=b8eec06c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8eec06c",
  null
  
)

export default component.exports